import editTemplate from 'templates/elements/guide/edit.mustache';
import showTemplate from 'templates/elements/guide/show.mustache';

export default class guideElement {
  constructor(options) {
    this.learnEditor = options.editor ? options.editor : null;

    this.savedGuideTitle = '';
    this.savedGuideId = '';
    this.savedPageTitle = '';
    this.savedPageId = '';
    this.savedImageUrl = '';
    this.activeElementId;

    this.init();
  }

  init() {
    $(document).on('click', '.add-build-guide', this.newElement.bind(this));
    $(document).on('click', '.build-guide', this.editElement.bind(this));

    $(document).on('click', '.submit-build-guide', this.submitElement.bind(this));
    $(document).on('click', '.cancel-build-guide', this.cancelElement.bind(this));
    $(document).on('click', '.delete-build-guide', this.deleteElement.bind(this));
    $(document).on('change', '.guide-search', this.guideSelected.bind(this));
  }

  shouldShowButton() {
    return true;
  }

  addButtonTemplate() {
    return '<a class="add-build-guide" href="#"><i class="fa fa-align-left"></i>Guide</a>';
  }

  newElement(event) {
    event.preventDefault();

    //only one editor should be enabled at a time
    if (this.learnEditor.is_editor_enabled()) {
      return;
    }

    var $activeButtonBar = $(event.target).closest('.button-bar, .bottom-button-bar');
    var $editTemplate = $(editTemplate.render({disabled: true}));
    $activeButtonBar.replaceWith($editTemplate);

    this.learnEditor.center_in_view($editTemplate);
    this.learnEditor.editing();

    this.enableDropdowns();
  }

  guideSelected(event) {
    $('.select2-pages').val(null).trigger('change');
    $(".select2-pages").prop("disabled", false);
  }

  editElement(event) {
    event.preventDefault();

    //only one editor should be enabled at a time
    if (this.learnEditor.is_editor_enabled()) {
      return;
    }

    var $element = $(event.currentTarget)
    var guideTitle = $(event.currentTarget).find('.guide-title').val();
    var guideId = $(event.currentTarget).find('.guide-id').val();
    var pageTitle = $(event.currentTarget).find('.page-title').val();
    var pageId = $(event.currentTarget).find('.page-id').val();
    var imageUrl = $(event.currentTarget).find('.image-url').val();

    self.activeElementId = $element.attr('id');
    self.activePosition = $element.data('position');
    this.savedGuideTitle = guideTitle;
    this.savedGuideId = guideId;
    this.savedPageTitle = pageTitle;
    this.savedPageId = pageId;
    this.savedImageUrl = imageUrl;

    $element.replaceWith($(editTemplate.render({
      guide_title: guideTitle,
      guide_id: guideId,
      page_title: pageTitle,
      page_id: pageId,
      disabled: false
    })));

    this.learnEditor.center_in_view($('.build-guide-wrapper'));
    this.learnEditor.editing();

    this.enableDropdowns();
  }

  submitElement(event) {
    event.preventDefault();

    let guideTitle = $('.select2-guides').find("option:selected").attr("title");
    let guideId = $('.select2-guides').val();
    let pageTitle = $('.select2-pages').find("option:selected").attr("title");
    let pageId = $('.select2-pages').val();

    this.createElement(guideTitle, guideId, pageTitle, pageId, null);
    this.clearAttributes();
    this.learnEditor.save_page("Before added guide Element‰");
  }

  cancelElement(event) {
    event.preventDefault();

    if (this.savedGuideTitle || this.savedPageTitle) {
      this.createElement(this.savedGuideTitle, this.savedGuideId, this.savedPageTitle, this.savedPageId, this.savedImageUrl);
      this.clearAttributes();
    } else {
      $('.build-guide-wrapper').remove();
    }

    this.learnEditor.finishEditing();
  }

  clearAttributes() {
    this.savedGuideTitle = "";
    this.savedGuideId = "";
    this.savedPageTitle = "";
    this.savedPageId = "";
    self.activeElementId = "";
    self.activePosition = "";
  }

  deleteElement(event) {
    event.preventDefault();

    if (!confirm("Confirm deletion of this element.")) {
      return;
    }

    this.clearAttributes();
    $('.build-guide-wrapper').remove();

    this.learnEditor.save_page("Before deleted guide Element‰");
  }

  createElement(guideTitle, guideId, pageTitle, pageId, imageUrl) {
    var $showTemplate = $(showTemplate.render({
      guide_id: guideId,
      guide_title: guideTitle,
      page_id: pageId,
      page_title: pageTitle,
      id: self.activeElementId || "",
      position: self.activePosition || "",
      image_url: imageUrl
    }));

    $('.build-guide-wrapper').replaceWith($showTemplate);
  }

  enableDropdowns() {
    if ($('input[name="page_type"]').val() === 'user') {
      var requestUrl = "/api/guides/presentable.json";
    } else {
      var requestUrl = "/admin/guides/presentable.json";
    };

    $(".select2-guides").select2({
      placeholder: 'Search for a guide',
      ajax: {
        url: requestUrl,
        datatype: 'json',
        delay: 250,
        minimumInputLength: 3,
        data: function (params) {
          var query = {
            search: params.term,
            page: params.page || 1
          }

          // Query parameters will be ?search=[term]&page=[page]
          return query;
        },
        processResults: function(data) {
          if (data.guide) {
            var guideOption = new Option(data.guide.title, data.guide.id, true, true);
            $(".select2-guides").append(guideOption).trigger('change');

            var pageOption = new Option(data.page.title, data.page.id, true, true);
            $(".select2-pages").append(pageOption).trigger('change');

            // manually trigger the `select2:select` event
            $(".select2-guides, .select2-pages").trigger({
                type: 'select2:select',
                params: {
                    data: data
                }
            });
          }

          return {
           results: data.guides
          };
        }
      },
      escapeMarkup: function(m) {
        return m;
      },
      templateResult: function(repo) {
        if (repo.loading) {
          return repo.text;
        }

        return `<div class='select2-guide-result'>
          <div class='image-container image-container'>
            <img class="image-preview" src="${repo.image_url}" />
          </div>
          <div class='details'>
            <div class='title'>${repo.title}</div>
            <div class='author'>By ${repo.author}</div>
            <div class='tagline'>${repo.tagline}</div>
          </div>
        </div>`
      },
      templateSelection: function(repo) {
        return repo.title || repo.text;
      }
    });

    var that = this;
    $(".select2-pages").select2({
      placeholder: 'Search for a page',
      allowClear: true,
      ajax: {
        url: function (params) {
          if ($('input[name="page_type"]').val() === 'user') {
            var requestUrlBase = "/api/guides/";
          } else {
            var requestUrlBase = "/admin/guides/";
          };

          return requestUrlBase + $(".select2-guides").val() + "/pages.json";
        },
        datatype: 'json',
        delay: 250,
        minimumInputLength: 3,
        processResults: function(data) {
          return {
           results: data
          };
        }
      },
      minimumResultsForSearch: Infinity,
      templateResult: function(repo) {
        if (repo.loading) {
          return repo.text;
        }

        return repo.title || repo.text;
      },
      templateSelection: function(repo) {
        return repo.title || repo.text;
      }
    });
  }
}
